var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnTableCellAdopt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3C11.5594 4.60734 13.5948 5.44422 15.6748 5.33333C15.9776 6.53346 16.0703 7.79225 15.9472 9.03492C15.8242 10.2776 15.4881 11.4788 14.9587 12.5671C14.4293 13.6554 13.7176 14.6086 12.8657 15.3702C12.0139 16.1317 11.0393 16.6859 10 17C8.96066 16.6859 7.98611 16.1317 7.13427 15.3702C6.28243 14.6086 5.57068 13.6554 5.04131 12.5671C4.51195 11.4788 4.17577 10.2776 4.05275 9.03492C3.92974 7.79225 4.0224 6.53346 4.32522 5.33333C6.40522 5.44422 8.44055 4.60734 10 3Z",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10L9.30769 12L13 8",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTableCellAdopt);
export default __webpack_public_path__ + "static/media/icn_table_cell_adopt.dcb6928bc636b01368d02210fe9cb651.svg";
export { ForwardRef as ReactComponent };